import { Menu, MenuItem } from '@mui/material';

import strings from 'constants/index';

export const HeaderLogoutMenu = ({ anchorEl, handleClose, handleLogoutButtonClick, disabled }) => (
  <Menu
    id="user-main-action-menu"
    anchorEl={anchorEl}
    keepMounted
    open={Boolean(anchorEl)}
    onClose={handleClose}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'right',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'right',
    }}
  >
    <MenuItem onClick={handleLogoutButtonClick} data-testid="logout" disabled={disabled}>
      {strings.logout}
    </MenuItem>
  </Menu>
);
